<template>
  <div class="mainSkuImgWrap">
    <div class="mainSkuImgCon">
        <el-table
            :border="true"
            :highlight-current-row="false"
            :data="tableData"
            style="width: 100%"
        >
            <el-table-column
                prop="skcName"
                align="center"
                :label="specifications[0] ? specifications[0].name : ''"
                width="200"
            >
            </el-table-column>
            <el-table-column
                prop="img1"
            >
                <template slot="header" slot-scope="scope">
                    <div>
                        <span style="color: red;">*</span>细节图
                        <el-tooltip class="item" effect="dark" content="细节图最多11张，宽高比例3:4至1:1之间均可，像素900px-2200px；大小≤3MB，格式JPG/JPEG/PNG" placement="top">
                            <i style="margin-right: 5px;font-size:16px;color:#666;" class="el-icon-question" />
                        </el-tooltip>
                    </div>
                </template>
                <template slot-scope="{ row,$index }">
                    <MutiImgUpload
                        :ref="`mutiImgUploadRef1_${$index}`"
                        class="mutiImgUpload"
                        v-model="row.img1" 
                        :mainImgNums="1" 
                        :limitWidth="[0, 0]" 
                        :limitHeight="[0, 0]" 
                        :limitSize="3 * 1024 * 1024" 
                        :size="200"
                        limitSuffix=".jpg,.jpeg,.png" 
                        :limitNums="10"
                        :aspectRatio="[1340/1785,1]"
                        :aspectRatioText="'1340:1785'"
                        :isSingle="true"
                        :isCheckImg="true"
                    />
                </template> 
            </el-table-column>
            <el-table-column
                prop="img2"
            >
                <template slot="header" slot-scope="scope">
                    <div>
                        <span style="color: red;">*</span>方型图
                        <el-tooltip class="item" effect="dark" content="方形图900px*900px-2200px*2200px；大小≤3MB，格式JPG/JPEG/PNG;" placement="top">
                            <i style="margin-right: 5px;font-size:16px;color:#666;" class="el-icon-question" />
                        </el-tooltip>
                    </div>
                </template>
                <template slot-scope="{ row,$index }">
                    <MutiImgUpload
                        :ref="`mutiImgUploadRef2_${$index}`"
                        class="mutiImgUpload"
                        v-model="row.img2" 
                        :mainImgNums="0" 
                        :limitWidth="[900, 2200]" 
                        :limitHeight="[900, 2200]" 
                        :limitSize="3 * 1024 * 1024" 
                        :size="200"
                        limitSuffix=".jpg,.jpeg,.png" 
                        :limitNums="1"
                        :aspectRatio="1"
                        :aspectRatioText="'1:1'"
                        :isSingle="true"
                        :isCheckImg="true"
                    />
                </template> 
            </el-table-column>
            <el-table-column
                prop="img3"
                label="色块图"
            >
                <template slot="header" slot-scope="scope">
                    <div>
                        <span style="color: red;">*</span>色块图
                        <el-tooltip class="item" effect="dark" content="色块图80px*80px；大小≤3MB，格式JPG/JPEG/PNG;" placement="top">
                            <i style="margin-right: 5px;font-size:16px;color:#666;" class="el-icon-question" />
                        </el-tooltip>
                    </div>
                </template>
                <template slot-scope="{ row,$index }">
                    <MutiImgUpload
                        :ref="`mutiImgUploadRef3_${$index}`"
                        class="mutiImgUpload"
                        v-model="row.img3" 
                        :mainImgNums="0" 
                        :limitWidth="[80, 0]" 
                        :limitHeight="[80, 0]" 
                        :limitSize="3 * 1024 * 1024" 
                        :size="200"
                        limitSuffix=".jpg,.jpeg,.png" 
                        :limitNums="1"
                        :aspectRatio="1"
                        :aspectRatioText="'1:1'"
                        :isSingle="true"
                        :isCheckImg="true"
                    />
                </template> 
            </el-table-column>
        </el-table>
    </div>
  </div>
</template>

<script>
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';

export default {
  components: {
    MutiImgUpload
  },
  props: {
    formData:{
        type: Object,
        default() {
            return {};
        }
    },
    specifications:{
        type: Array,
        default() {
            return [];
        }
    },
    skcMainImg:{
        type: Array,
        default() {
            return [];
        }
    }
  },
  data() {
    return {
        tableData:[],
        isCheckWhiteImg:false
    };
  },
  computed: {
    skcLabel(){
        let obj = this.specifications[0] || {}
        return obj.name
    }
  },
  watch: {
    specifications:{
        handler(val) { 
            let obj = val[0];
            let skcList = obj?.values || [];
            let list = []
            list = skcList.map(item => {
                let obj = this.skcMainImg.find(i => (i.attributeId == item.propId && i.attributeValueId == item.propValueId));
                let skcImageInfoList = obj ? obj.skcImageInfoList : [];
                return {
                    attributeId:item.propId,
                    attributeValueId:item.propValueId,
                    skcName:item.value,
                    img1:skcImageInfoList.filter(i => [1,2].includes(i.imageType)).map(i => i.imageUrl),
                    img2:skcImageInfoList.filter(i => i.imageType === 5).map(i => i.imageUrl),
                    img3:skcImageInfoList.filter(i => i.imageType === 6).map(i => i.imageUrl),
                    skcImageInfoList:skcImageInfoList
                }
            });
            this.tableData = list;
        },
        deep:true,
        immediate: true,
    },
    tableData:{
        handler(v){
            this.$emit('change',v)
        },
        deep:true
    }
  },
  mounted() {

  },
  methods: {
    async method_validImage(){
        let imgTypeMap = {
            1:'细节图',
            2:'方形图',
            3:'色块图',
        }
        for(let i = 0; i < this.tableData.length; i++){
            let skcName = this.tableData[i].skcName;
            let errorText = ''
            for(let j = 1; j <= 3; j++){
                let ref = `mutiImgUploadRef${j}_${i}`;
                let errMsg = await this.$refs[ref].method_validImage()
                if(errMsg){
                    errorText = skcName+'：'+imgTypeMap[j]+errMsg;
                    break;
                }
            }
            if(errorText){
                return errorText
            }
        }
         return null
    }
  },
};
</script>

<style lang="scss" scoped>
.mainSkuImgWrap{
    ::v-deep .cell {
        padding: 10px;
    }
    // .mutiImgUpload {
    //     ::v-deep .sc-upload{
    //         margin: 0;
    //     }
    // }
}
</style>